import type { TFunction } from "i18next";
import { TUserRole, TUserStatus, TAccessMode } from "../services/schemas";
import { UserRole } from "@libs/shared-permissions";

type TSettingsT = TFunction<"settings">;

export const getMemberRoles = (
  t: TSettingsT,
  currentUserRole?: UserRole
): {
  label: string;
  value: TUserRole;
}[] => {
  const baseRoles: { label: string; value: TUserRole }[] = [
    { label: t("roles.clientUser"), value: "clientUser" },
    { label: t("roles.clientAdmin"), value: "clientAdmin" }
  ];

  if (currentUserRole === "systemAdmin") {
    baseRoles.push({ label: t("roles.systemAdmin"), value: "systemAdmin" as TUserRole });
  }

  return baseRoles;
};

export const memberStatuses = (
  t: TSettingsT
): {
  label: string;
  value: TUserStatus;
}[] => [
  { label: t("statuses.active"), value: "active" },
  { label: t("statuses.inactive"), value: "inactive" }
];

export const getAccessModes = (
  t: TSettingsT
): {
  label: string;
  value: TAccessMode;
}[] => [
  { label: t("accessModes.edit"), value: "edit" },
  { label: t("accessModes.read"), value: "read" }
];

export const STATUS_KEYS = {
  active: "statuses.active",
  pending: "statuses.pending",
  inactive: "statuses.inactive",
  expired: "statuses.expired"
} as const;

export const ACCEPTED_FILE_TYPES = ["image/jpeg", "image/jpg", "image/png", "image/webp"];
export const MAX_FILE_SIZE = 5 * 1024 * 1024;
